import http from '@/utils/request';

export const fetchSiteJson = () => {
  const { VITE_RMT_DOMAIN, VITE_SITE_ID } = import.meta.env;
  return http.get<Site.SiteInfo>(
    `${VITE_RMT_DOMAIN}/json/config/${VITE_SITE_ID}/site.sitejson`,
  );
};
